import { useMutation } from '@sequencehq/api'
import { useBulkActions } from './useBulkActions'
import { dashboard20240730Client } from '@sequencehq/api/dashboard/v20240730'
import { useCallback } from 'react'
import { BulkActionType } from '../types'

export const useMarkCompletedBulkActionsAsReviewed = (
  types: BulkActionType[]
) => {
  const { bulkActions } = useBulkActions({ types })

  const reviewBulkAction = useMutation(
    dashboard20240730Client.postReviewBulkAction
  )

  return useCallback(() => {
    const bulkActionsToMarkAsReviewed = bulkActions.filter(
      bulkAction => bulkAction.status === 'COMPLETED' && !bulkAction.reviewedAt
    )
    for (const bulkAction of bulkActionsToMarkAsReviewed) {
      reviewBulkAction.mutate({ id: bulkAction.id })
    }
  }, [bulkActions, reviewBulkAction])
}
